import { collectionDesigns } from "./collectionDesigns";
import { purpleDesigns } from "./purpleDesigns";
import type { CertificateStyle } from "../../../domain/certificates/certificateTemplates";
import type { CertificateDesign } from "./certificateParts";
import { championDesign } from "./championDesign";
import { classicDesign } from "./classicDesign";
import { elegantDesign } from "./elegantDesign";
import { modernDesign } from "./modernDesign";
import { ornateDesign } from "./ornateDesign";
import { playfulDesign } from "./playfulDesign";
import { schoolbooksDesign } from "./schoolbooksDesign";
import { prestigeDesign } from "./prestigeDesign";
import { bumblebeeDesign } from "./bumblebeeDesign";
import { geometricDesign } from "./geometricDesign";
import { rainbowDesign } from "./rainbowDesign";
import { lagoonDesign } from "./lagoonDesign";
import { breezeDesign } from "./breezeDesign";

/** How each style draws a certificate. The only place a style is chosen. */
export const CERTIFICATE_DESIGNS: Record<CertificateStyle, CertificateDesign> =
  {
    ...purpleDesigns,
    ...collectionDesigns,
    champion: championDesign,
    classic: classicDesign,
    elegant: elegantDesign,
    modern: modernDesign,
    playful: playfulDesign,
    ornate: ornateDesign,
    schoolbooks: schoolbooksDesign,
    prestige: prestigeDesign,
    bumblebee: bumblebeeDesign,
    geometric: geometricDesign,
    rainbow: rainbowDesign,
    lagoon: lagoonDesign,
    breeze: breezeDesign,
  };
